import React from 'react'
import { Dialog, DialogPassThroughOptions, DialogProps } from 'primereact/dialog'
import './PrimeDialog.scss'

export type PrimeDialogPassThroughOptions = DialogPassThroughOptions

export interface PrimeDialogProps extends DialogProps {
  modalRef?: React.RefObject<Dialog>
  'data-testid'?: string
  'close-button-data-testid'?: string
}

export const PrimeDialog: React.FC<PrimeDialogProps> = ({
  appendTo,
  ariaCloseIconLabel,
  baseZIndex,
  blockScroll,
  breakpoints,
  children,
  className,
  closable,
  closeOnEscape,
  content,
  contentClassName,
  contentStyle,
  dismissableMask,
  draggable,
  focusOnShow,
  footer,
  header,
  headerClassName,
  closeIcon,
  headerStyle,
  icons,
  id,
  keepInViewport,
  maskClassName,
  maskStyle,
  maximizable,
  maximized,
  minX,
  minY,
  modal,
  position,
  modalRef,
  resizable,
  rtl,
  showHeader,
  maximizeIcon,
  minimizeIcon,
  style,
  transitionOptions,
  visible,
  pt,
  ptOptions,
  unstyled,
  onClick,
  onDrag,
  onDragEnd,
  onDragStart,
  onHide,
  onMaskClick,
  onMaximize,
  onResize,
  onResizeEnd,
  onResizeStart,
  onShow,
  'data-testid': dataTestId,
  'close-button-data-testid': closeButtonDataTestId,
}) => (
  <Dialog
    appendTo={appendTo || (document.getElementById('root')?.children[0] as HTMLElement)}
    {...(ariaCloseIconLabel !== undefined && { ariaCloseIconLabel })}
    {...(baseZIndex !== undefined && { baseZIndex })}
    {...(blockScroll !== undefined && { blockScroll })}
    {...(breakpoints !== undefined && { breakpoints })}
    {...(className !== undefined && { className })}
    {...(closable !== undefined && { closable })}
    {...(closeOnEscape !== undefined && { closeOnEscape })}
    {...(content !== undefined && { content })}
    {...(contentClassName !== undefined && { contentClassName })}
    {...(contentStyle !== undefined && { contentStyle })}
    {...(dismissableMask !== undefined && { dismissableMask })}
    {...{ draggable: draggable ?? false }}
    {...(focusOnShow !== undefined && { focusOnShow })}
    {...(footer !== undefined && { footer })}
    {...(header !== undefined && { header })}
    {...(headerClassName !== undefined && { headerClassName })}
    {...(closeIcon !== undefined && { closeIcon })}
    {...(headerStyle !== undefined && { headerStyle })}
    {...(icons !== undefined && { icons })}
    {...(id !== undefined && { id })}
    {...(keepInViewport !== undefined && { keepInViewport })}
    {...{ maskClassName: maskClassName ?? 'mk-dialog__mask' }} // seems to not work -- PrimeReact bug!
    {...(maskStyle !== undefined && { maskStyle })}
    {...(maximizable !== undefined && { maximizable })}
    {...(maximized !== undefined && { maximized })}
    {...(minX !== undefined && { minX })}
    {...(minY !== undefined && { minY })}
    {...(modal !== undefined && { modal })}
    {...(position !== undefined && { position })}
    {...(modalRef !== undefined && { ref: modalRef })}
    {...{ resizable: resizable ?? false }}
    {...(rtl !== undefined && { rtl })}
    {...(showHeader !== undefined && { showHeader })}
    {...(maximizeIcon !== undefined && { maximizeIcon })}
    {...(minimizeIcon !== undefined && { minimizeIcon })}
    {...(style !== undefined && { style })}
    {...(transitionOptions !== undefined && { transitionOptions })}
    {...(visible !== undefined && { visible })}
    {...(pt !== undefined || dataTestId !== undefined || closeButtonDataTestId !== undefined
      ? {
          pt: {
            ...pt,
            root: {
              ...(pt?.root || {}),
              ...(dataTestId !== undefined && { 'data-testid': dataTestId }),
            },
            closeButton: {
              ...(pt?.closeButton || {}),
              ...(closeButtonDataTestId !== undefined && { 'data-testid': closeButtonDataTestId }),
            },
          },
        }
      : {})}
    {...(ptOptions !== undefined && { ptOptions })}
    {...(unstyled !== undefined && { unstyled })}
    {...(onClick !== undefined && { onClick })}
    {...(onDrag !== undefined && { onDrag })}
    {...(onDragEnd !== undefined && { onDragEnd })}
    {...(onDragStart !== undefined && { onDragStart })}
    {...(onHide !== undefined ? { onHide } : { onHide: () => {} })}
    {...(onMaskClick !== undefined && { onMaskClick })}
    {...(onMaximize !== undefined && { onMaximize })}
    {...(onResize !== undefined && { onResize })}
    {...(onResizeEnd !== undefined && { onResizeEnd })}
    {...(onResizeStart !== undefined && { onResizeStart })}
    {...(onShow !== undefined && { onShow })}>
    {children}
  </Dialog>
)
